import React from "react";
import { Row } from "react-bootstrap";
import SingleProject from "./SingleProject/SingleProject";

const portfolioData = [
    {
        id: 101,
        title: "Camera Choice",
        name: "Camera Choice Shop BD",
        type: "Full-Stack",
        banner: "https://i.ibb.co/2jYpr3m/camera-choice-banner.png",
        img: "https://i.ibb.co/7zzyyR6/camera-com.jpg",
        technology: [
            "Html",
            "CSS",
            "Material UI",
            "React",
            "React-Router",
            "Context API",
            "NodeJS",
            "ExpressJS",
            "CryptoJS",
            "MongoDB",
        ],
        tools: ["Firebase", "Github", "VS Code", "Heroku", "Environment file"],
        liveSite: "https://camera-choice.web.app/",
        clientCode: "https://github.com/naimurnemu/Camera-choice-react",
        serverCode: "https://github.com/naimurnemu/camera-choice-node",
        description: [
            "This website about A online Camera shop.",
            "There have 4 main route. Some private route for Logged user.",
            "I use Firebase login system for registration and login.",
            "I use Mongodb No SQL database.Cors use for Http middle ware.",
            "This web site have admin panel.",
            "There only admin can access Admin route, make admin, and can manage order and product.",
        ],
    },
    {
        id: 102,
        title: "Tour Holiday",
        name: "Tour Holiday- Enjoy Holiday",
        type: "Full-Stack",
        banner: "https://i.ibb.co/R3D57SX/tour-holiday-banner.jpg",
        img: "https://i.ibb.co/yhXL6Mg/tour-com.jpg",
        technology: [
            "Html",
            "CSS",
            "Bootstrap",
            "React",
            "React-Router",
            "Context API",
            "NodeJS",
            "ExpressJS",
            "MongoDB",
        ],
        tools: ["VS Code", "Github", "Firebase", "Heroku", "Environment file"],
        liveSite: "https://tour-holiday.web.app/",
        clientCode: "https://github.com/naimurnemu/Tour-holiday-React",
        serverCode: "https://github.com/naimurnemu/Tour-holiday-Node",
        description: [
            " Here I use React library to design a tourism related Website.",
            "I use React-Bootstrap for css and also use some row css to make design authentic.",
            "In this web site i do CRUD operation by Node express.",
            "Home, packages, about, and tour tips is available for all.",
            "For edit service and order need login to website.",
            "Database is No-SQL mongoDB atlas.",
        ],
    },
    {
        id: 103,
        title: "Safe Health",
        name: "Safe Health Clinic",
        type: "Front-End",
        banner: "https://i.ibb.co/dLyC4Kp/safe-health-banner.jpg",
        img: "https://i.ibb.co/c8J4Hvk/safe-com.jpg",
        technology: [
            "Html",
            "CSS",
            "Bootstrap",
            "React",
            "React-Router",
            "Context API",
            "npm",
        ],
        tools: ["VS Code", "Github", "Firebase"],
        liveSite: "https://safe-health-d8c56.web.app/",
        clientCode: "https://github.com/naimurnemu/Safe-health-hospital",
        description: [
            "This is A Website about an online hospital. There is detail about this hospital.",
            "Here I create 3 section To describe hospital.",
            "I create a dynamic route for more detail . services has a banner. and hospital has 6 service",
            "here I create only 2 component. one in emergency service detail. another is about owner of hospital.",
            "Login system here I use React Google Firebase logIn system. I also host this project in firebase.",
        ],
    },
];

const ProjectsPortfolio = () => {
    return (
        <div>
            <div className="py-4">
                <h2 className=" fw-bolder border-bottom border-3 border-info d-inline">
                    Top Projects
                </h2>
            </div>
            <div className="container">
                <Row xs={1} md={2} lg={3} className="g-4">
                    {portfolioData.map((singleProject) => (
                        <SingleProject
                            key={singleProject.id}
                            singleProject={singleProject}
                        />
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default ProjectsPortfolio;
